import { AssociateCandidatesComponent } from "./associate-candidates.component";
export const AssociateCandidatesModule = angular
    .module('associateCandidates', [])
    .component(AssociateCandidatesComponent.selector, AssociateCandidatesComponent.component)
    .name;
//# sourceMappingURL=associate-candidates.module.js.map